module.exports = __webpack_public_path__ + "img/ico-default-img.68bf1938.svg";